/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Change_Detection_Starting_StatusInputs */

const en_scene_change_detection_starting_status = /** @type {(inputs: Scene_Change_Detection_Starting_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting shot change detection...`)
};

const fr_scene_change_detection_starting_status = /** @type {(inputs: Scene_Change_Detection_Starting_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demarrage de la detection de changement de plan...`)
};

const de_scene_change_detection_starting_status = /** @type {(inputs: Scene_Change_Detection_Starting_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erkennung von Änderungen beim Startschuss...`)
};

const it_scene_change_detection_starting_status = /** @type {(inputs: Scene_Change_Detection_Starting_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvio del rilevamento del cambio di inquadratura...`)
};

const ru_scene_change_detection_starting_status = /** @type {(inputs: Scene_Change_Detection_Starting_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обнаружение изменения начального удара...`)
};

const es_scene_change_detection_starting_status = /** @type {(inputs: Scene_Change_Detection_Starting_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detección de cambio de disparo inicial...`)
};

const zh_cn2_scene_change_detection_starting_status = /** @type {(inputs: Scene_Change_Detection_Starting_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始投篮变化检测……`)
};

const ja_scene_change_detection_starting_status = /** @type {(inputs: Scene_Change_Detection_Starting_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショット変更検出を開始しています...`)
};

const hi_scene_change_detection_starting_status = /** @type {(inputs: Scene_Change_Detection_Starting_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शॉट परिवर्तन का प्रारंभिक पता लगाना...`)
};

const pt_pt2_scene_change_detection_starting_status = /** @type {(inputs: Scene_Change_Detection_Starting_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detecção de mudança de tiro inicial...`)
};

/**
* | output |
* | --- |
* | "Starting shot change detection..." |
*
* @param {Scene_Change_Detection_Starting_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_change_detection_starting_status = /** @type {((inputs?: Scene_Change_Detection_Starting_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Change_Detection_Starting_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_scene_change_detection_starting_status(inputs)
	if (locale === "de") return de_scene_change_detection_starting_status(inputs)
	if (locale === "it") return it_scene_change_detection_starting_status(inputs)
	if (locale === "ru") return ru_scene_change_detection_starting_status(inputs)
	if (locale === "es") return es_scene_change_detection_starting_status(inputs)
	if (locale === "zh-CN") return zh_cn2_scene_change_detection_starting_status(inputs)
	if (locale === "ja") return ja_scene_change_detection_starting_status(inputs)
	if (locale === "hi") return hi_scene_change_detection_starting_status(inputs)
	if (locale === "pt-PT") return pt_pt2_scene_change_detection_starting_status(inputs)
	return en_scene_change_detection_starting_status(inputs)
});